module.exports = __webpack_public_path__ + "static/media/5.e0894d93.webp";